import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DarkInput, PrimaryButton, FieldWrapper } from 'ui';

import { Trans } from 'react-i18next';

import { signInPath } from 'constants/urls';
import { Form, Field } from 'formik';

import boehringerLogo from 'public/logo_st.png';
import stLogo from 'public/soundtalks-logo.png';

import Icon from 'components/core/icon';
import { FluidPreloader } from 'components/core/preloader';

import HeaderShared from './layout/header';
import FooterShared from './layout/footer';
import SubTitleShared from './layout/subtitle';

import s from './styles.scss';

const ResetPassword = ({ className, isSubmitting, handleSubmit }) => (
  <div className={cx(s.sharedForm, className, s.sharedFormSignIn)}>
    <HeaderShared className={s.sharedFormHeader}>
      <div className={s.sharedFormHeaderLogo} style={{ backgroundImage: `url(${boehringerLogo})` }} />
      <div className={s.sharedFormHeaderSt}>
        <div className={s.sharedFormHeaderStTitle}>
          {' '}
          <Trans i18nKey="powered_by" />
        </div>
        <div className={s.sharedFormHeaderStLogo} style={{ backgroundImage: `url(${stLogo})` }} />
      </div>
    </HeaderShared>
    <div>
      <SubTitleShared className={s.sharedFormSubtitle}>Would you like to reset your password?</SubTitleShared>
      <SubTitleShared className={s.sharedFormSubtitle}>If so, please enter your email address below.</SubTitleShared>
    </div>
    <Form>
      <Field
        id="email"
        name="email"
        placeholder="Email Address"
        component={FieldWrapper}
        inputComponent={DarkInput}
        className={s.sharedFormField}
      />

      <PrimaryButton type="submit" className={s.sharedFormSubmit} onClick={handleSubmit}>
        {isSubmitting ? <FluidPreloader light /> : <Trans i18nKey="reset_password" />}
      </PrimaryButton>
    </Form>
    <FooterShared className={s.sharedFormFooterReset}>
      <Link to={signInPath} className={s.sharedFormFooterLink}>
        <Icon className={s.sharedFormFooterLinkIcon} icon={Icon.icons.arrowLeft} />
        Back
      </Link>
    </FooterShared>
  </div>
);

ResetPassword.defaultProps = {
  className: null,
};

ResetPassword.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default ResetPassword;
